import React from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  getUsuarioDepara,
  rotuloOrigemDoVinculo,
  ORCAMENTO_CILIA_HABILITADO,
} from '../../../api/orcamentoCiliaApi';
import { queryKeys } from '../../../infrastructure/react-query/queryKeys';

/**
 * orcamento-cilia/at-13: o vínculo do usuário com o Nasajon, só leitura, no modal de usuários.
 *
 * O vínculo vive no módulo Requisições (backend próprio) e é gerido em Administração do Sistema →
 * Requisições; aqui ele só é MOSTRADO, para quem cadastra pessoas saber se ela consegue enviar
 * requisição. Mesma lista da tela de configuração (mesma chave de cache).
 *
 * 🔴 Falha de carga nunca vira "sem vínculo" (regra da at-60): "sem vínculo" manda alguém ao
 * cadastro; "não foi possível consultar" é o módulo fora do ar.
 */
const VinculoNasajonDoUsuario: React.FC<{ userId: string }> = ({ userId }) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: queryKeys.orcamentoCilia.usuarioDepara,
    queryFn: getUsuarioDepara,
    enabled: ORCAMENTO_CILIA_HABILITADO,
  });

  if (!ORCAMENTO_CILIA_HABILITADO) return null;

  let texto: string;
  if (isLoading) {
    texto = 'Consultando...';
  } else if (isError || !data) {
    texto = 'Não foi possível consultar o vínculo com o Nasajon.';
  } else {
    const vinculo = data.find((v) => v.userIdSoac === userId);
    texto = vinculo
      ? `${vinculo.nasajonNome || vinculo.nasajonLogin || vinculo.nasajonUserId} (${rotuloOrigemDoVinculo(vinculo.origem)})`
      : 'Sem vínculo. É feito sozinho quando o e-mail é igual nos dois sistemas.';
  }

  return (
    <div className="Frame1000004010">
      <div className="Frame1000003994">
        <div className="Campo">
          <div className="CampoTitulo">Usuário no Nasajon (Requisições)</div>
          <div className="CampoInput">
            <input className="Input" readOnly value={texto} title={texto} aria-label="Usuário no Nasajon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VinculoNasajonDoUsuario;
